import React from "react";
import "./NuLife.css";
import { NavbarJourney } from "../Navbar/NavbarJourney";
import LifeStep from "./LifeStep";
export default function Numlife() {
  return (
    <>
      <NavbarJourney />
      <section
        className="py-4"
        style={{ minHeight: "calc(100vh - 50px)", backgroundColor: "#edf6ff" }}
      >
        <div className="row justify-content-around">
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
            <div className="position-relative">
              <div className="position-absolute health-fr-txt">
                <h4 className="text-blue text-center">
                  Save upto 85%* on Life Insurance
                </h4>
                <p className="text-center">Stay home & renew in 2 minutes</p>
                <div className="d-flex align-items-center mt-3 mb-3 justify-content-center">
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fflash.png?alt=media&token=c7213ae8-4a09-4a72-9800-e6eb5e59ff75"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-success fw-bold">
                    Instant Policy
                  </small>
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fbank.png?alt=media&token=4cc16690-6e13-4219-a6ff-dd513fe04d1f"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-warning fw-bold">
                    Best Prices
                  </small>
                  <img
                    style={{ width: 20 }}
                    src="https://firebasestorage.googleapis.com/v0/b/goodfood-659aa.appspot.com/o/Icons%2FBike_Ins%2Fdocuments.png?alt=media&token=7923cd01-4150-4801-a4bf-8a42120125c9"
                    alt=""
                  />
                  <small className="me-4 ms-2 text-info fw-bold">
                    No Paperwork
                  </small>
                </div>
              </div>
              <img
                className="img-fluid"
                src="./Images/posp-login.png"
                width={500}
                alt=""
              />
            </div>
          </div>
          <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12">
            <LifeStep />
          </div>
        </div>
      </section>
    </>
  );
}
